import { forwardRef, type Ref, type SVGProps } from "react";
const IconPasteOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M22 6h-2a2.006 2.006 0 0 0-2-2h-1.18a2.988 2.988 0 0 0-5.64 0H10a2.006 2.006 0 0 0-2 2H6a2.006 2.006 0 0 0-2 2v20a2.006 2.006 0 0 0 2 2h4v-2H6V8h2a2.006 2.006 0 0 0 2 2h8a2.006 2.006 0 0 0 2-2h2v2h2V8a2.006 2.006 0 0 0-2-2m-4 2h-8V6h3V5a1 1 0 0 1 2 0v1h3Z" />
    <path d="M26 12H14a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h12a2.006 2.006 0 0 0 2-2V14a2.006 2.006 0 0 0-2-2m0 16H14V14h12Z" />
    <path d="M24 21a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1" />
    <path d="M24 17a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1" />
  </svg>
);
const ForwardRef = forwardRef(IconPasteOutlineSVG);
ForwardRef.displayName = "IconPasteOutline";
export { ForwardRef as IconPasteOutline };
